import apps from "./apps";
import account from "./account";

const data = [
  ...account,
  ...apps,
];

export default data;
